module.exports = __webpack_public_path__ + "media/images/image-placeholder-3-3369e7b6817f6d51fd027d5d65a5df8e.jpg";